/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */
import React from "react";
import { ScrollView } from "react-native";

import { TranscriptionBlock } from "UpduoLibrary";
import { skaleLightGray } from "config/UpduoColors";

interface TranscriptionProps {
  transcriptJson?: any;
}

export default function Transcription({ transcriptJson }: TranscriptionProps) {
  let runningTime = 0;
  return (
    <ScrollView
      style={{
        borderRadius: 5,
        borderColor: skaleLightGray,
        borderWidth: 1,
        marginTop: 10,
        paddingTop: 25,
        paddingLeft: 25,
        paddingRight: 25,
        paddingBottom: 17,
      }}
    >
      {transcriptJson.map((block) => {
        runningTime += block.ts;
        return (
          <TranscriptionBlock
            name={`Speaker ${block.speaker + 1}`}
            text={block.text}
            key={runningTime}
            timestamp={Math.floor(runningTime)}
          />
        );
      })}
    </ScrollView>
  );
}
